import type { EmrIntegrationDto } from '@/shared/api/modules/contracts';
import type { EmrIntegration } from '../model/types';

export const transformEmrIntegrationDtoToEmrIntegration = (
  dto: EmrIntegrationDto | null
): EmrIntegration => {
  return {
    isIntegrated: !!dto,
    lastSyncedAt: dto?.lastSyncedAt ?? null,
    createdAt: dto?.createdAt ?? null,
  };
};
